<p-chart type="bar" [data]="data" [options]="options" class="w-full h-64 md:h-96"></p-chart>
